export default __webpack_public_path__ + "static/media/breadcrumb.71981757.png";